import { render, staticRenderFns } from "./ChooseStudent.vue?vue&type=template&id=c341b67e&scoped=true"
import script from "./ChooseStudent.vue?vue&type=script&lang=js"
export * from "./ChooseStudent.vue?vue&type=script&lang=js"
import style0 from "./ChooseStudent.vue?vue&type=style&index=0&id=c341b67e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c341b67e",
  null
  
)

export default component.exports